import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { FiShoppingBag, FiMenu, FiX, FiSearch } from 'react-icons/fi';
import './Header.css';

const Header = () => {
  const { getCartCount } = useCart();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/shop?search=${searchQuery}`);
      setSearchQuery('');
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="header">
      <div className="header-sale-banner">
        <div className="sale-marquee-track">
          <div className="sale-marquee-content">
            <span className="sale-item">🔥 Sale is Live! Use code <strong>PET10</strong> for 10% off</span>
            <span className="sale-dot">✦</span>
            <span className="sale-item">🔥 Sale is Live! Use code <strong>PET10</strong> for 10% off</span>
            <span className="sale-dot">✦</span>
            <span className="sale-item">🔥 Sale is Live! Use code <strong>PET10</strong> for 10% off</span>
            <span className="sale-dot">✦</span>
            <span className="sale-item">🔥 Sale is Live! Use code <strong>PET10</strong> for 10% off</span>
            <span className="sale-dot">✦</span>
            <span className="sale-item">🔥 Sale is Live! Use code <strong>PET10</strong> for 10% off</span>
            <span className="sale-dot">✦</span>
            <span className="sale-item">🔥 Sale is Live! Use code <strong>PET10</strong> for 10% off</span>
            <span className="sale-dot">✦</span>
          </div>
        </div>
      </div>
      <div className="header-top">
        <div className="container">
          <p className="header-announcement">
            Free shipping on orders over ₹999
          </p>
        </div>
      </div>
      
      <nav className="navbar">
        <div className="container">
          <div className="navbar-content">
            <Link to="/" className="logo">
              <span className="logo-text">PAWKIT</span>
            </Link>

            <div className="nav-links desktop">
              <Link to="/" className="nav-link">Home</Link>
              <Link to="/shop?petType=dog" className="nav-link">Dogs</Link>
              <Link to="/shop?petType=cat" className="nav-link">Cats</Link>
              <Link to="/shop" className="nav-link">Shop All</Link>
              <Link to="/track-order" className="nav-link">Track Order</Link>
            </div>

            <div className="nav-actions">
              <form onSubmit={handleSearch} className="search-form desktop">
                <FiSearch className="search-icon" />
                <input
                  type="text"
                  placeholder="Search products..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="search-input"
                />
              </form>

              <Link to="/cart" className="cart-btn">
                <FiShoppingBag size={22} />
                {getCartCount() > 0 && (
                  <span className="cart-badge">{getCartCount()}</span>
                )}
              </Link>

              <button 
                className="mobile-menu-btn"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                aria-label="Toggle menu"
              >
                {mobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="mobile-menu animate-slide-in">
              <form onSubmit={handleSearch} className="search-form mobile">
                <FiSearch className="search-icon" />
                <input
                  type="text"
                  placeholder="Search products..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="search-input"
                />
              </form>
              
              <div className="nav-links">
                <Link to="/" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
                  Home
                </Link>
                <Link to="/shop?petType=dog" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
                  Dogs
                </Link>
                <Link to="/shop?petType=cat" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
                  Cats
                </Link>
                <Link to="/shop" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
                  Shop All
                </Link>
                <Link to="/track-order" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
                  Track Order
                </Link>
              </div>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;
